import type { ChartType, Plugin } from 'chart.js'

declare module 'chart.js' {
  interface Chart {
    $cursor?: { x: number; y: number }
  }
}

export const trackCursor: Plugin<ChartType> = {
  id: 'trackCursor',
  afterEvent(chart, args) {
    const e = args.event

    if (!e.x || !e.y) return

    // Chart.js normalized coordinates (relative to canvas)
    chart.$cursor = { x: e.x, y: e.y }
  }
}
